/* eslint-disable */
import reducer from './reducer';
import operation from './operation';
export { operation };
export default reducer;
